import { getMe } from "../../../utils/bridges/methods";

export const getIsEMRPlanExpired = () => {
  const pst = getMe()?.user?.cc?.pst ?? "true";
  const pex = getMe()?.user?.cc?.pex ?? 0;
  const isExpired = pex && (pst === "false" || pex * 1000 < Date.now());
  return isExpired;
};
